"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 92.027v15.51a.868.868 0 00.229.248l10.651 3.159 1.32.391.375 1.323c.934 3.29 2.349 6.611 4.022 9.73l.633 1.18-.63 1.18-5.428 10.162c0 .009 0 .025.004.045a.222.222 0 00.02.065l.009.014 11.17 11.217.01.006a.224.224 0 00.058.019c.016.003.03.003.038.003l10.11-5.446 1.188-.639 1.187.641c3.1 1.675 6.412 3.097 9.69 4.039l1.319.38.387 1.318 3.21 10.917a.436.436 0 00.102.011h15.576a.932.932 0 00.242-.228l3.146-10.7.388-1.32 1.322-.379c3.274-.937 6.58-2.357 9.685-4.037l1.187-.643 1.189.64 10.114 5.448a.208.208 0 00.101-.029L42.5 92.027zm0 0l10.825-2.96 1.358-.372.386-1.354c.94-3.293 2.355-6.621 4.024-9.735l.632-1.18-.63-1.179L53.67 65.09 42.5 92.027zm65.223 65.486l.004-.002-.004.002zm-65.234-50l.001.004a.013.013 0 010-.004z",
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 27.5,
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 79v21.5H117",
    stroke: props.color || "#133251",
    strokeWidth: 5
  }));
}

var _default = SvgScreenMaintenance;
exports["default"] = _default;